/* eslint-disable max-len */

export default {
    name       : 'relatedOperations',
    /**
     * @override
     */
    data() {
        return {
            uuid: null,
            relatedOperations: [],
            intervenerIsBlocked: false,
            accountIsBlocked: false
        };
    },
    props: {
        type: {
            type: String,
            required: true
        },
        limit: {
            type: Number,
            required: false
        },
        id: {
            type: String,
            required: false
        },
        operations: {
            type: Array,
            required: false
        }
    },
    methods: {
        /**
         * Obtenemos la información relativa a las operaciones a:
         * - interviniente
         * - cuenta
         * - operación
         */
        fetchData() {
            this.uuid = this.id || this.$route.params.uuid;
            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            let metodo;
            switch (this.type) {
                case 'intervener':
                    metodo = this.$intervenersService.getIntervenerOperations;
                    this.relatedOperations.fields = this.relatedOperations.fields.filter(x => x.key !== 'operation_date');
                    this.setIntervenerIsBlocked();
                    break;
                case 'account':
                    metodo = this.$accountsService.getAccountOperations;
                    this.relatedOperations.fields = this.relatedOperations.fields.filter(x => x.key !== 'operation_date');
                    this.setAccountIsBlocked();
                    break;
                case 'periodic_operation_request':
                case 'operation_request':
                    metodo = this.$operationsService.getOperationSuboperations;
                    this.relatedOperations.fields = this.relatedOperations.fields.filter(x => x.key !== 'operation_date');
                    break;
                default:
                    break;
            }

            if (metodo) {
                metodo(this.uuid, cfg)
                    .then(res => {
                        this.relatedOperations.items = res.data.related_operations || res.data.intervener_operations || res.data.operations;
                        this.relatedOperations.items = this.relatedOperations.items.map(operation => {
                            switch (operation.amount_shares_indicator) {
                                case 'I':
                                    operation.amount = `${this.$options.filters.yuriCurrency(operation.net_amount)} (Neto)`;
                                    break;
                                case 'P':
                                    operation.amount = `${operation.shares} (Participaciones)`;
                                    break;
                                case 'B':
                                default:
                                    if (operation.is_total_redemption || operation.is_total_transfer) {
                                        operation.amount = 'Total';
                                    } else {
                                        operation.amount = `${this.$options.filters.yuriCurrency(operation.gross_amount)} (Bruto)`;
                                    }
                                    break;
                            }
                            return operation;
                        });
                    });
            }
        },
        /**
         * Opens operation_add with the account filter active
         */
        clickOperationNew() {
            const _route = {
                name: 'operations_add',
                params: [],
                query: {
                    uuid: this.uuid,
                    type: this.type
                }
            };
            const item = {
                route: _route,
                name: 'Operaciones',
                active: true
            };
            this.$store.dispatch('yuriMenuStore/disableItemsMenu')
                .then(() => {
                    this.$store.dispatch('yuriMenuStore/upsertItem', item)
                        .then(() => {
                            this.$router.replace(item.route);
                        });
                    this.$store.dispatch('yuriMenuStore/setActiveItem', item);
                });
        },

        setIntervenerIsBlocked() {
            this.$intervenersService.getIntervenersByUUIId(this.uuid, {})
            .then( res => this.intervenerIsBlocked = res.data.intervener.intervener_status === 'BLOQUEADO' );
        },

        setAccountIsBlocked() {
            this.$accountsService.getAccountsByUUId(this.uuid)
            .then( res => this.accountIsBlocked = res.data.account.status === 'BLOQUEADO' );
        }
    },
    /**
     * @override
     */
    beforeMount() {

        this.relatedOperations = {
            fields: [
                {
                    key: 'request_date',
                    label: 'Solicitud'
                },
                {
                    key: 'operation_date',
                    label: 'Fecha Operación'
                },
                {
                    key: 'id_object',
                    label: 'Operación',
                    class: 'operation_code'
                },
                {
                    key: 'key_operation_type',
                    label: 'Tipo de operación'
                },
                {
                    key: 'key_sub_operation_type',
                    label: 'Subtipo de operación'
                },
                {
                    key: 'key_product',
                    label: 'Fondo'
                },
                {
                    key: 'operation_status',
                    label: 'Estado',
                    class: 'operation_status'
                },
                {
                    key: 'amount',
                    label: 'Importe',
                    class: 'amount'
                }
            ],
            items: []
        };
        this.fetchData();
    }
};
